/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Goal, saveGoal, deleteGoal } from 'api/fakeAPI'
import { AppThunk } from 'app/store'

const initialState: Array<Goal> = []

const goals = createSlice({
  name: 'goals',
  initialState: initialState,
  reducers: {
    addGoal(state, { payload }: PayloadAction<Goal>) {
      state.push(payload)
    },
    removeGoal(state, { payload }: PayloadAction<string>) {
      return state.filter((goal) => goal.id !== payload)
    }
  }
})

export const { addGoal, removeGoal } = goals.actions

export default goals.reducer

export const handleDeleteGoal =
  (goal: Goal): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(removeGoal(goal.id))
      await deleteGoal(goal.id)
    } catch (err: any) {
      console.log('there was an error deleting the goal ' + err)
      dispatch(addGoal(goal))
    }
  }

export const handleAddGoal =
  (text: string, cb: () => void): AppThunk =>
  async (dispatch) => {
    try {
      const toDo = await saveGoal(text)
      dispatch(addGoal(toDo))
      cb()
    } catch (err: any) {
      console.log('there was an error adding goal ' + err.toString())
    }
  }
